import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
     CircularProgress,
     LinearProgress,
    TextField
} from "@material-ui/core";
import IntlMessages from "../../../util/IntlMessages";
import {useForm} from "react-hook-form";
import {
    registerCloudIntegrationAWS, registerCloudIntegrationAzure,
    registerCloudIntegrationDigitalOcean,
    unregisterCloudIntegration
} from "../../../actions";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import BBExternalLink from "../accents/BBExternalLink";
import BBIconCircleRightChevron from "../../../assets/bbCustomIcons/BBIconCircleRightChevron";
import {
    bbGetApplicableCloudIntegrationsOfTypeForEntity,
    bbIsCloudIntegrationTypeActiveForEntity, bbIsCloudIntegrationTypeActiveWithErrorsForEntity
} from "../../../util/bbHelpers";
import {Tooltip} from "@mui/material";
import BBIconCodeDocument from "../../../assets/bbCustomIcons/BBIconCodeDocument";
import BBCodeCopyContainer from "../controllers/BBCodeCopyContainer";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 400,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            // width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    // const classes = useStyles();
    const {entityId, integrationOption, integrationObjects} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    // const {authUser, token, refreshToken,} = useSelector(({auth}) => auth);
    const {cloudIntegrations, loadingCloudIntegrationRegistration, loadingCloudIntegrationRegistrationError} = useSelector(({breachrisk}) => breachrisk);
    const {entityInView} = useSelector(({breachrisk}) => breachrisk);
    const { didJustRegisterCloudIntegration, didJustUnregisterCloudIntegration } = useSelector(({breachrisk}) => breachrisk.appMisc)
    const dispatch = useDispatch();
    // const history = useHistory();

    const isCloudEnabled = bbIsCloudIntegrationTypeActiveForEntity(entityInView, integrationOption.id, integrationObjects);
    const applicableIntegrations = bbGetApplicableCloudIntegrationsOfTypeForEntity(entityInView, integrationOption.id, integrationObjects);
    const integrationInView = applicableIntegrations ? applicableIntegrations[Object.keys(applicableIntegrations).pop()] : null;

    const isAWS = integrationOption && integrationOption.id && integrationOption.id === 2;
    const isAzure = integrationOption && integrationOption.id && integrationOption.id === 3;
    const isDigitalOcean = integrationOption && integrationOption.id && integrationOption.id === 1;

    // const isActiveButErroredIntegrations = bbIsCloudIntegrationTypeActiveWithErrorsForEntity(entityInView, integrationOption.id, integrationObjects);
    // const isRegistrationStepComplete = isActiveButErroredIntegrations && !isAzure;

    const integrationRequiredDetails = integrationOption && integrationOption.required_details;
    const awsIntegrationRequiredDetailBBAccountId = integrationRequiredDetails && integrationRequiredDetails.breachbits_account_id;
    const awsIntegrationRequiredDetailExternalId = integrationRequiredDetails && integrationRequiredDetails.external_id;
    const awsIntegrationRequiredDetailPolicyDefinitionJSON = integrationRequiredDetails && integrationRequiredDetails.policy_definition;

    // const [customerId, setCustomerId] = useState(null);
    const [formEntityId, setFormEntityId] = useState(entityId);
    const [cloudType, setCloudType] = useState(integrationOption && integrationOption.id ? integrationOption.id : null);
    const [userDescription, setUserDescription] = useState(null);
    const [awsRoleArnString, setAwsRoleArnString] = useState(null);
    const [tenentId, setTenentId] = useState(null);
    const [appId, setAppId] = useState(null);
    const [clientSecret, setClientSecret] = useState(null);
    // const [skipRegistrationStep, setSkipRegistrationStep] = useState(false);
    // const [showRegistrationStepEvenIfJustSubmitted, setShowRegistrationStepEvenIfJustSubmitted] = useState(false);
    const [showDigitalOceanStep2, setShowDigitalOceanStep2 ] = useState(false);

    const clearForm = () => {
        // setUserDescription(null);
        // setAwsRoleArnString(null);
        // setTenentId(null);
        // setAppId(null);
        // setClientSecret(null);
        // isDigitalOcean
        //     && didJustRegisterCloudIntegration
        //     && setShowDigitalOceanStep2(false);
        document.getElementById('cloudRegistrationForm').reset();
    }

  // useEffect(() => {
  //     console.log("Checking to see if should skip to second step for cloud integration", "skipRegistrationStep",  skipRegistrationStep, "isCloudEnabled", isCloudEnabled, "isRegistrationStepComplete", isRegistrationStepComplete, "isActiveButErroredIntegrations", isActiveButErroredIntegrations)
  //   if(!skipRegistrationStep && !isCloudEnabled && isRegistrationStepComplete) {
  //       console.log("Skipping registration step")
  //       setSkipRegistrationStep(true);
  //   }

    // if (!isCloudEnabled){
    //     console.log("There are no applicable integrations, resetting skip registration step")
    //     setSkipRegistrationStep(false);
    // }
  // }, [dispatch, integrationObjects, loadingCloudIntegrationRegistration, loadingCloudIntegrationRegistrationError, skipRegistrationStep, cloudIntegrations]);

    // const { register, handleSubmit, errors } = useForm();
    const cloudRegistrationFormHooks = useForm();
    // const verificationFormHooks = useForm();

    const onSubmitRegistration = data => {
        // setLocalLoading(true);
        // console.log("Dispatching cloud registration form with ", data, "integration type id of ", integrationOption.id, "formEntityId", formEntityId, "userDescription", userDescription, "skipRegistrationStep", skipRegistrationStep,  "showRegistrationStepEvenIfJustSubmitted", showRegistrationStepEvenIfJustSubmitted);
        console.log("Dispatching cloud registration form with ", data, "integration type id of ", integrationOption.id, "formEntityId", formEntityId, "userDescription", userDescription, );

        if(integrationOption){
            switch (integrationOption.id) {
                case 1:
                    dispatch(registerCloudIntegrationDigitalOcean(formEntityId, userDescription))
                    setShowDigitalOceanStep2(true);
                    break;
                case 2:
                    dispatch(registerCloudIntegrationAWS(formEntityId, userDescription, awsRoleArnString));
                    clearForm()
                    break;
                case 3:
                    console.log("Azure integration registration submitted. Values being sent: entityId,", formEntityId, "userDescription", userDescription, "tenentId", tenentId, "appId", appId, "clientSecret", clientSecret)
                    dispatch(registerCloudIntegrationAzure(formEntityId, userDescription, tenentId, appId, clientSecret))
                    clearForm()
                    break;
                default:
                    console.warn("attempted to submit registration with an integration option id out of range.")
                    break;
            }

        }

    }

    const onGoToCloudProvider = data => {
        console.log("Headed to cloud provider to authenticate and finalize cloud integration.");

        //check to verify there is an integration URL
        if(entityInView && cloudIntegrations && integrationInView && integrationInView.registration_url){
            //TODO: do some checking of the URL to make sure it is well formed before sending.
            console.log("Redirecting to ", integrationInView.registration_url);
            window.location = integrationInView.registration_url;
        } else {
            console.log("Attempted to redirect to cloud integration URL but there is none in the state that match entity.", entityInView, cloudIntegrations);
        }
    }

    const restartCloudProcess = data => {
        console.log("Restarting the Cloud Registration process.", applicableIntegrations);

        //pick one of the integrations

        if(integrationInView) {
            const removeThisOne = integrationInView.id;
            console.log("removing", removeThisOne, integrationInView);
            dispatch(unregisterCloudIntegration(removeThisOne, "Starting Cloud Integratino Process Over"));
            setShowDigitalOceanStep2(false);
        } else {
            console.log("No integrationInView to remove.")
        }


    }


  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const registrationForm = <form id={"cloudRegistrationForm"} className="animated fadeIn animation-duration-7">
        {isAWS && integrationRequiredDetails
            ? <>
                <h2>AWS Integration Preparation</h2>
                <p>To make this integration, you'll need to obtain an AWS Role ARN. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View Detailed How-To</BBExternalLink>}</p>
                <h3>You will need to use the following information:</h3>
                <ul>
                    <li>Account ID: <code>{awsIntegrationRequiredDetailBBAccountId}</code></li>
                    <li>External ID: <code>{awsIntegrationRequiredDetailExternalId}</code></li>
                    <li>You must configure the AWS Policy Definition. <small>For your convenience, we've provided a policy JSON block that you can paste into the AWS interface that gives us the required permissions:</small></li>
                </ul>
                <BBCodeCopyContainer displayText={JSON.stringify(awsIntegrationRequiredDetailPolicyDefinitionJSON,null, '\t')} titleDescriber={"AWS Policy Definition"} titleIcon={<BBIconCodeDocument className={"text-electric-blue"}/>}/>
                <h3>Once you use the information above, AWS will provide you a Role ARN. Please provide that ARN below to complete the integration.</h3>
                <br/>
            </>
            :   null
        }

        {isDigitalOcean
            ? <>
                <h2>Step 1 of 3: Register
                    <LinearProgress variant={"determinate"} value={33} className={"max-width-25p"}/>
                </h2>
                <p>Provide a description (optional) and select "Start Integration" to get started. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View How-To</BBExternalLink>}</p>
            </>
            : null
        }

        {isAzure
            ? <>
                <h2>
                    Azure Integration
                </h2>
                <p>To make this integration, you will need to provide information from your <BBExternalLink tipText={"Open the Azure portal in a separate tab."} href={"https://portal.azure.com"}> Azure account. </BBExternalLink></p>
                <h3>You will need to provide the following information: {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View How-To</BBExternalLink>}</h3>
                <ul>
                    <li>Tenet ID</li>
                    <li>App ID</li>
                    <li>Client Secret</li>
                </ul>
            </>
            : null}

            <div className={"row"}>
                <div className={"col-12"}>

                    
                    <TextField
                        label={<IntlMessages id="appModule.cloudIntegration.register.userDescription"/>}
                        fullWidth
                        id="userDescription"
                        name="userDescription"
                        // required
                        error={!!cloudRegistrationFormHooks.errors.userDescription}
                        onChange={(event) => setUserDescription(event.target.value)}
                        defaultValue={`${userDescription ? userDescription : ""}`}
                        margin="normal"
                        className="mt-1 my-sm-3"
                        // inputRef={cloudRegistrationFormHooks.register({
                        //     required: <>Required and must include your <BBExternalLink tipText={"Find your Country Calling code on Wikipedia in a new tab"} href={"https://en.wikipedia.org/wiki/List_of_country_calling_codes#Alphabetical_listing_by_country_or_region"}>Country Calling code</BBExternalLink> without spaces. ex: 112345678901 or +112345678901</> ,
                        //     pattern: /^\+?[1-9][0-9]{1,14}$/
                        //
                        // })}
                        helperText={"Notes for your internal use."}
                        autoComplete={"off"}
                    />

                    {isAWS &&
                        <TextField
                            label={"AWS Role ARN"}
                            fullWidth
                            id="awsRoleArnString"
                            name="awsRoleArnString"
                            required
                            error={!!cloudRegistrationFormHooks.errors.awsRoleArnString}
                            onChange={(event) => setAwsRoleArnString(event.target.value)}
                            defaultValue={`${awsRoleArnString ? awsRoleArnString : ""}`}
                            margin="normal"
                            className="mt-1 my-sm-3"
                            inputRef={cloudRegistrationFormHooks.register({
                                required: <>Required. You get this information from AWS.</> ,
                                // pattern: /^\+?[1-9][0-9]{1,14}$/

                            })}
                            autoComplete={"off"}
                            helperText={<>This code string is generated by AWS when you create a role for BreachBits. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View AWS How-To</BBExternalLink>}</>}
                        />
                    }

                    {isAzure &&
                        <>
                            <TextField
                                label={"Tenent ID"}
                                fullWidth
                                id="tenentId"
                                name="tenentId"
                                required
                                error={!!cloudRegistrationFormHooks.errors.tenentId}
                                onChange={(event) => setTenentId(event.target.value)}
                                defaultValue={`${tenentId ? tenentId : ""}`}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={cloudRegistrationFormHooks.register({
                                    required: <>Required. You get this information from Azure.</> ,
                                    // pattern: /^\+?[1-9][0-9]{1,14}$/

                                })}
                                autoComplete={"off"}
                                helperText={<>This code string is generated by {integrationOption.name}. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View {integrationOption && integrationOption.name} How-To</BBExternalLink>}</>}
                            />

                            <TextField
                                label={"App ID"}
                                fullWidth
                                id="appId"
                                name="appId"
                                required
                                error={!!cloudRegistrationFormHooks.errors.appId}
                                onChange={(event) => setAppId(event.target.value)}
                                defaultValue={`${appId ? appId : ""}`}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={cloudRegistrationFormHooks.register({
                                    required: <>Required. You get this information from Azure.</> ,
                                    // pattern: /^\+?[1-9][0-9]{1,14}$/

                                })}
                                autoComplete={"off"}
                                helperText={<>This code string is generated by {integrationOption.name}. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View {integrationOption && integrationOption.name} How-To</BBExternalLink>}</>}
                            />

                            <TextField
                                label={"Client Secret"}
                                fullWidth
                                id="clientSecret"
                                name="clientSecret"
                                required
                                error={!!cloudRegistrationFormHooks.errors.clientSecret}
                                onChange={(event) => setClientSecret(event.target.value)}
                                defaultValue={`${clientSecret ? clientSecret : ""}`}
                                margin="normal"
                                className="mt-1 my-sm-3"
                                inputRef={cloudRegistrationFormHooks.register({
                                    required: <>Required. You get this information from Azure.</> ,
                                    // pattern: /^\+?[1-9][0-9]{1,14}$/

                                })}
                                autoComplete={"off"}
                                helperText={<>This code string is generated by {integrationOption.name}. {integrationOption && integrationOption.documentation_url && <BBExternalLink tipText={"View our how-to article to help you complete this integration."} href={integrationOption.documentation_url}>View {integrationOption && integrationOption.name} How-To</BBExternalLink>}</>}
                            />
                        </>
                    }


                    <div>

                        <Button onClick={cloudRegistrationFormHooks.handleSubmit(onSubmitRegistration)}
                                disabled={ !!cloudRegistrationFormHooks.errors.userDescription}
                                variant="contained" color="primary"
                                endIcon= {<BBIconCircleRightChevron />}
                                className={"m-2"}
                                type={"submit"}
                        >
                            Start Integration

                        </Button>{loadingCloudIntegrationRegistration[entityId] && <CircularProgress size={26}/>}
                    </div>

                </div>
            </div>
        </form>

    const stepRedirectToCloudProvider = <>

        <div className={"row"}>
            <div className={"col-12"}>
                {entityInView
                && cloudIntegrations
                && integrationInView
                && integrationInView.registration_url
                    && showDigitalOceanStep2
                    && <>
                        <h2>Step 2 of 3: Authenticate with Cloud Provider

                            <LinearProgress variant={"determinate"} value={67} className={"max-width-25p"}/>

                        </h2>

                        <p>You're ready to log in to your cloud provider.</p>
                        <Tooltip title={`Final step: Authenticate at ${ integrationInView.registration_url }`}>
                        <Button onClick={() => onGoToCloudProvider()}
                            // disabled={ !!cloudRegistrationFormHooks.errors.userDescription}
                                variant="contained"
                                color="primary"
                                endIcon={<BBIconCircleRightChevron/>}
                                className={"m-2"}
                                type={"submit"}
                        >
                                Authenticate: Go to {integrationOption.name}

                            </Button>
                        </Tooltip>
                        <br/>
                        <Button onClick={() => restartCloudProcess()}
                            // disabled={true}
                                variant="contained"
                                // color="secondary"
                            // endIcon={<BBIconR/>}
                                className={"m-2 bg-light-grey"}
                                type={"submit"}
                        >
                            Cancel Integration

                        </Button>
                    </>
                    // : <>
                    //     <p>It looks like you've started the process, but then you were interrupted. Let's start over.</p>
                    //     <Button onClick={() => restartCloudProcess()}
                    //           // disabled={true}
                    //           variant="contained"
                    //           color="primary"
                    //           // endIcon={<BBIconR/>}
                    //           className={"m-2"}
                    //           type={"submit"}
                    //     >
                    //         Start Over
                    //
                    //     </Button>
                    // </>
                }

            </div>
        </div>
    </>

    console.log("cloudIntegrationRegistrationForm, for ", integrationOption, "isAWS", isAWS, "isDigitalOcean", isDigitalOcean, "isAzure", isAzure, "ShowDigitalOceanstep2", showDigitalOceanStep2 )

    return (
        <div className="animated fadeIn animation-duration-7">

            {
                // isCloudEnabled
                // ? cloudIsAlreadyEnabledForm
                // :
                !(isDigitalOcean && showDigitalOceanStep2) ?
                    registrationForm
                    : stepRedirectToCloudProvider
            }

        </div>
    );



}

export default Form